var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"label":"Tags","options":_vm.options,"multiple":true,"taggable":true},on:{"input":function ($e) { return _vm.$emit('input', $e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }